// export const appid = 'wx82b0fe6684826c3b' //测试 wx82b0fe6684826c3b
// export const appid = 'wx2ed00de38f02f4d4' //测试 wx2ed00de38f02f4d4
// export const appid = 'wx51cc9dc993f9498d' //众控
// export const appid = 'wx6b347e7a9cb13e61' //众控
// export const safetyUrl = 'http://10.10.10.41:1889' //微信开放平台绑定js安全域名//当前 Network
// export const appid = 'wx726f98c54dad4faa';
export const safetyUrl = 'https://datong.nbzkkj.cn' //微信开放平台绑定js安全域名
// export const safetyUrl = 'http://10.10.10.123:9000' //本地
// 大同公众号
export const appid = 'wx780847aa8321b027'

export const setToCodeUrl = (url = '') => {
  let redirect_uri = encodeURIComponent(`${safetyUrl}${url}`)
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`
}
